/**
 * Created by Denis Kuzin on 30 march 2022
 */

const ClansWindow = BaseClanWindow.extend({
    ctor: function (...args) {
        this.updateTop = true;

        this._super(...args);
    },

    onWindowLoaded: function () {
        this._super({
            name: "ClansWindow",
            title: Messages.get("ClansWindow.joiningTeam.title")
        });
    },

    createTabs: function () {
        return {
            0: {
                icon: bundles.clan.frames.tab_icon_join_team,
                text: Messages.get("ClansWindow.joiningTeam.title"),
                generator: this.createTab.bind(this, ClansJoinTab),
                updateTitle: this.setTitle.bind(this, Messages.get("ClansWindow.joiningTeam.title"))
            },
            1: {
                icon: bundles.clan.frames.tab_icon_top_team,
                text: Messages.get("ClansWindow.top.title"),
                generator: this.createTab.bind(this, ClansTopTab),
                updateTitle: this.setTitle.bind(this, Messages.get("ClansWindow.top.title"))
            }
        };
    },

    onHide: function () {
        this._super();

        if (this.tabs.getActive() === "0") {
            this.tabs.onUnSelectTab("0");
        }
    },

    onShow: function () {
        this._super();

        if (this.tabs.getActive() === "0") {
            this.tabs.onSelectTab("0");
        }
    }
});